<template>
  <div class="reward-form">
    <van-form ref="form">
      <van-field
        placeholder="姓名"
        name="username"
        v-model="model.accountUserName"
        :rules="[{ required: true, message: '姓名不能为空' }]"
        class="mb-2"
      />
      <van-field
        v-model="model.accountUserPhone"
        name="phone"
        placeholder="手机号"
        :rules="[
          { required: true, message: '手机号不能为空' },
          { validator: phoneValidator, message: '手机号码格式错误，请重新输入' }
        ]"
        class="mb-2"
      />
      <van-field
        v-if="isNeedExpress"
        v-model="model.accountUserExtraInfo"
        name="address"
        placeholder="详细地址"
        :rules="[{ required: true, message: '详细地址不能为空' }]"
        class="mb-2"
      />
      <van-field v-else-if="!isCoupon && extraInfo" v-model="model.accountUserExtraInfo" name="info" :placeholder="extraInfo" :rules="[{ required: true, message: '附加信息不能为空' }]" />
    </van-form>
    <van-button class="mt-2" size="small" block type="danger" @click="onReceive">领取</van-button>
    <div class="text-center mt-2">
      <p class="text-small">信息填写不正确会影响接收奖品</p>
      <p class="text-small">请在 15 分钟内提交获奖信息，逾期无法领取</p>
      <p class="text-small">如对奖品有疑问，请联系发布人</p>
    </div>
  </div>
</template>

<script>
import { ValidateRule } from 'dygc'

export default {
  name: 'RewardForm',
  data() {
    return {
      model: {
        accountUserName: '',
        accountUserPhone: '',
        accountUserExtraInfo: ''
      }
    }
  },
  computed:{
    isNeedExpress() {
      return this.$bus.currentAwardData?.bindAward?.lotteryCategory === 1
    },
    isCoupon(){
      return this.$bus.currentAwardData?.bindAward?.lotteryCategory === 3
    },
    extraInfo(){
      return this.$bus.currentAwardData?.bindAward?.extraInfo
    }
  },
  methods: {
    onReceive() {
      this.$refs.form.validate().then(isOk=>{
        this.$bus.receiveAward(this.model)
      })
    },
    phoneValidator(val) {
      return ValidateRule.phone(val.trim())
    }
  }
}
</script>

<style scoped></style>
